import { ReactNode, ReactElement } from "react";
import {
  ReactPlugin,
  AppInsightsContext,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const reactPlugin = new ReactPlugin();
const appInsights =
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_APP_INSIGHTS_INSTRUMENTATION_KEY
    ? new ApplicationInsights({
        config: {
          instrumentationKey:
            process.env.REACT_APP_APP_INSIGHTS_INSTRUMENTATION_KEY,
          loggingLevelConsole: 2,
          loggingLevelTelemetry: 2,
          autoTrackPageVisitTime: true,
          enableAutoRouteTracking: true,
          enableRequestHeaderTracking: true,
          enableResponseHeaderTracking: true,
          extensions: [reactPlugin],
        },
      })
    : null;
appInsights?.loadAppInsights();

const AppInsightsProvider = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => (
  <AppInsightsContext.Provider value={reactPlugin}>
    <AppInsightsErrorBoundary
      onError={() => <h1>I believe something went wrong</h1>}
      appInsights={reactPlugin}
    >
      <>{children}</>
    </AppInsightsErrorBoundary>
  </AppInsightsContext.Provider>
);

export default AppInsightsProvider;
